module.exports = __webpack_public_path__ + "img/hein.6eb3f579.jpg";